import { ObjectDb } from './object.db';
import { Injectable } from '@angular/core';
import { EmploymentGridItemObject } from '@libs/types/src/user/object-type/employment-grid.object';

@Injectable({ providedIn: 'root' })
export class EmploymentDb extends ObjectDb<EmploymentGridItemObject> {

    public tableName: string = 'employment';

    protected override columnMap = {};

    protected override indices = ['id', 'serviceId'];

    protected gqlMethod = 'getEmployments';

    protected syncFragment = `
        id
        userId
        serviceId
        dateFrom
        dateTo
        employmentTypeName
        employmentGroupName
    `;

}
